// extracted by mini-css-extract-plugin
export default {"header":"_27f35705","headerWrapper":"_5d383016","heading":"_5f3847d2","seeMoreLink":"_63bc2ffc","seeMoreIcon":"_ec66017"};